import type React from 'react';

import { StarterDashboardV2PageNotificationManagerContextProvider } from './context';
import { useStarterDashboardV2PageNotificationManager } from './hook';

export const StarterDashboardV2PageNotificationManagerProvider: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => {
	const notificationManager = useStarterDashboardV2PageNotificationManager();

	return (
		<StarterDashboardV2PageNotificationManagerContextProvider value={notificationManager}>
			{children}
		</StarterDashboardV2PageNotificationManagerContextProvider>
	);
};
